<kendo-dialog [width]="810" [height]="640" title="  " class="about-dialog"  (close)="onClose.emit()">
    <div class="shield-container">
        <img [src]="resources.images.philips"/>
    </div>
    <div class="product-name-container">
        <span>{{productName}}</span>
    </div>
    <div class="common-name-container">
        <span class="common-version">Release {{releaseVersion}}</span>
    </div>

    <div class="lot-ref-container">
        <div class="lot-symbol">LOT</div>
        <span class="lot-number">{{commercialVersion}}</span>
        <div class="ref-symbol">REF</div>
        <span class="ref-number">{{productCodeNumber}}</span>
    </div>

    <div class="main-text-container">
        <span [innerHTML]="copyrightMessageHTML" >
        </span>
        <p>
            Copyrights and all other proprietary rights in any software and related documentation ("Software") made available to you rest exclusively with Philips or its licensors. No title or ownership in the Software is conferred to you. Use of the Software is subject to the end user license conditions as are available on request.
        </p>
        <p>
            To the maximum extent permitted by law, you shall not decompile and/or reverse engineer the software or any part thereof.
        </p>
        <div [ngClass]="{'non-medical': isNonMedicalDevice}">Build:  {{commercialVersion}}_{{buildNumber}}</div>

        <span *ngIf="isNonMedicalDevice">Not for diagnostic, monitoring or therapeutic purposes or in any other manner for regular medical practice.</span>
        <span *ngIf="isUnreleasedDevice">The Workflow Information Management Enterprise Manager (WIP) V{{releaseVersion}} is provided on an “as is” basis without warranty of any kind, including without limitation, the warranty that it is free from defects. No use of the Workflow Information Management Enterprise Manager (WIP) V{{releaseVersion}} is authorized hereunder except under this disclaimer.</span>
    </div>

    <div class="manufacturer-name-address-container">
        <img [src]="resources.images.manufacturerSymbol" />
        <div class="name-address">
            <span>Philips Medical Systems Nederland B.V.</span>
            <span>Veenpluis 6, 5684 PC  Best, The Netherlands</span>
        </div>
    </div>
    <div class="about-footer-container">
         <a (click)="this.showUkImporter = true" class="uk-importer">Other Country Label</a>
        <img [src]="resources.images.consultSymbol" />
        <a href="https://www.philips.com/IFU" target="_blank">eIFU</a>
        <img class="caution-symbol" [ngClass]="{'unreleased' : isUnreleasedDevice}" [src]="resources.images.cautionSymbol" />
        <span *ngIf="isUnreleasedDevice"  class="caution-text">For evaluation purposes only</span>
        <div class="manufacturer-date">
            <img class="manufacturer-symbol" [src]="resources.images.manufacturerDateSymbol" />
            <span>{{buildDate}}</span>
        </div>
        <div class="udi-hri-container" [ngClass]="{'unreleased' : isUnreleasedDevice}">
            <span>(01)00884838125292</span>
            <span>(10){{commercialVersion}}(11){{buildDateUDI}}</span>
        </div>
    </div>
</kendo-dialog>

<kendo-dialog *ngIf="this.showUkImporter" [width]="400" [height]="300" title="Other Country Label" class="other-country-label"  (close)="this.showUkImporter = false">
  <div class="header">
    UK Importer
  </div>
  <div class="content">
    Philips Electronics UK Limited<br>
    Ascent 1<br>
    Farnborough Aerospace Centre<br>
    Farnborough<br>
    GU14 6XW<br>
  </div>
</kendo-dialog>
